import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message__info__checkbox",
  "use": "message__info__checkbox-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"message__info__checkbox\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <rect fill=\"var(--color-primary-lighter, #374f67)\" width=\"14\" height=\"14\" rx=\"2\" />\n    <path stroke=\"var(--color-icons-alt, #fff)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.898 6.752 6.781 8.5l3.231-3\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol